import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import MappingIntro from './MappingIntro';
import ImportHooray from './ImportHooray';

const ImportSuccess = ({ onMappingStart }) => {
  const [showIntro, setShowIntro] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setShowIntro(true), 2000);
    return () => clearTimeout(timer);
    }, []
  );

  return (showIntro)
    ? <MappingIntro onMappingStart={onMappingStart}/>
    : <ImportHooray />;
};

ImportSuccess.propTypes = {
  onMappingStart: PropTypes.func
};

export default ImportSuccess;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/ImportSuccess.jsx